import { render, staticRenderFns } from "./newPieChart.vue?vue&type=template&id=5f182eb2&scoped=true"
import script from "./newPieChart.vue?vue&type=script&lang=js"
export * from "./newPieChart.vue?vue&type=script&lang=js"
import style0 from "./newPieChart.vue?vue&type=style&index=0&id=5f182eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f182eb2",
  null
  
)

export default component.exports